import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-modal-mensagem-horizontal',
    templateUrl: './modal-mensagem-horizontal.page.html',
    styleUrls: ['./modal-mensagem-horizontal.page.scss'],
})

export class ModalMensagemHorizontalPage {
    header: string;
    body: string;
    footer: string;
    btnLeftText: string;
    btnRightText: string;

    constructor(
        private modalController: ModalController,
    ) {
    }

    clickLeftBtn() {
        this.modalController.dismiss();
    }

    clickRightBtn() {
        this.modalController.dismiss(true);
    }
}
